import OrdersFormComponent from "components/OrdersFormComponent";
import React, { Component, useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom/cjs/react-router-dom.min";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Badge,
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';

const UserOrders = () => {

    const [formName, setFormName] = useState("")
    const [user,setUser] = useState({})


    useEffect(()=> {
        const pathname = window.location.pathname; 
        setUser(JSON.parse(localStorage.getItem("authUser")).user)
        switch (pathname) {
            case "/user/create-order":
                setFormName("Order")
                break;
            case "/user/create-vector":
                setFormName("Vector")
                break;
            case "/user/create-quote":
                setFormName("Quote")
                break;
            default:
                break;
        }
    },[])
    const toggle = () =>{
        return null;
    }
    
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Create {formName}</title>
                </MetaTags>
                <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                    <Container fluid>
                        <Breadcrumbs title="Orders/" breadcrumbItem={`Create ${formName}`} />
                        <Row>
                            <Col lg="6">
                                <Card>
                                    <CardBody>
                                        <OrdersFormComponent requestFor={formName} orderRec={user} toggle={() => toggle(1)}/>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    )

}

export default UserOrders;
